import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../../api/klydo";

const useRejectPublicationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["reject-publication"],
    mutationFn: ({
      klydoId,
      message,
    }: {
      klydoId: string;
      message: string;
    }) => {
      return klydoApiClient.rejectPublication(klydoId, message);
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["klydos"] });
      queryClient.refetchQueries({ queryKey: ["klydosList"] });
    },
  });
};

export default useRejectPublicationMutation;
